export function freezeMap(map) {
  if (!(map instanceof Map)) {
    throw new TypeError("freezeMap expects a Map instance");
  }
  const throwFrozen = () => {
    throw new Error(
      "Cannot mutate a frozen Map. Create a local copy instead (new Map(original)).",
    );
  };
  map.set = throwFrozen;
  map.delete = throwFrozen;
  map.clear = throwFrozen;
  Object.freeze(map);
  return map;
}
